import URI from "urijs";
export const urlAnterior = document
    ?.querySelector('meta[name="url-anterior"]')
    ?.getAttribute("content");
export const urlAtual = window.location.href.indexOf('#') !== -1 ? window.location.href.substr(0, window.location.href.indexOf('#')) : window.location.href;
/** Retorna os parametros do hash
 * Exemplo: #/festas/create?data=2022-08-04]
 * Retorna {data:'2022-08-04'}
*/
export const getHashParams = () => {
    const u = new URI(window.location.hash.substring(1));
    return u.search(true);
};
export default {};
